import React, { useState } from "react";
import "./App.scss";

import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import homeRoutes from "./navigation/homeRoutes";

import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { themeMJB } from "./styles/theme/themeMaterialUI";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/configureStore";
import { LayoutContextProvider } from "./utils/LayoutContext/LayoutContext";
import { InfoModalProvider } from "./common/components/organisme/InfoModalV2/context/infoModalV2Context";
import { ToastProvider } from "./common/providers/ToastProvider";

function App() {
  const routesList = homeRoutes;

  const defaultTheme = createTheme(themeMJB);
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
      }),
  );
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={defaultTheme}>
          <InfoModalProvider>
            <BrowserRouter>
              <LayoutContextProvider>
                <QueryClientProvider client={queryClient}>
                  <ToastProvider>
                    <Routes>
                      {routesList.map((route, index) => {
                        return (
                          <Route
                            key={index}
                            path={route.path}
                            element={<route.main />}
                          />
                        );
                      })}
                    </Routes>
                  </ToastProvider>
                </QueryClientProvider>
              </LayoutContextProvider>
            </BrowserRouter>
          </InfoModalProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
